import React, { Component, useState } from "react";
import Progress from "./CustomTool/Progress";
import { Grid } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  mapSetActiveMenuToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import { fetchGSTInfo } from "./API";
import CtBtn from "./CustomTool/CtBtn";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import IconButton from "@mui/material/IconButton";

class GstInfo extends Component {
  state = {
    dataLoadStatus: true,
    formData: {
      txtCaptcha: "",
      txtGSTIN: "",
    },
    base64String: "",
    captchaCookie: "",
  };

  componentDidMount() {
    this.setState({
      formData: { ...this.state.formData, txtGSTIN: this.props.vac_gstin },
    });
    this.handleConvertToBase64();
  }

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        // if (e.target.name === "txtGSTIN") {
        //   let Gstno = this.props.vac_gstin;
        //   this.setState({
        //     formData: { ...this.state.formData, txtGSTIN: Gstno },
        //   });
        // }
      }
    );
  };

  // handleConvertToBase64 = () => {
  //   const reqData = {
  //     Op: "GetCaptcha",
  //   };
  //   fetchGSTInfo(reqData)
  //     .then((res) => {
  //       this.setState({
  //         base64String: res.data.content,
  //         captchaCookie: res.data.captchaCookie,
  //       });
  //       console.log("first", res.data.content);
  //     })
  //     .catch((error) => {
  //       console.log("Unknown error occurred in getInfo.", error);
  //     });
  //   console.log("base64String", this.state.base64String);
  // };

  handleConvertToBase64 = () => {
    let dataLoadStatus = false;
    this.setState(
      {
        dataLoadStatus,
      },
      () => {
        const reqData = {
          Op: "GetCaptcha",
        };
        fetchGSTInfo(reqData)
          .then((res) => {
            // console.log(res);
            dataLoadStatus = true;
            let base64String = res.data.message.content,
              captchaCookie = res.data.message.captchaCookie;
            this.setState(
              {
                base64String,
                captchaCookie,
                dataLoadStatus, // Set dataLoadStatus to true after the data is fetched
              },
              () => {
                document.getElementById("txtCaptcha").focus();
              }
            );
            // console.log("base64String", base64String);
            // console.log("captchaCookie", captchaCookie);
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in handleConvertToBase64.",
              error
            );
          });
      }
    );
  };

  validateCaptcha = () => {
    let result = false;
    if (this.state.formData.txtCaptcha.trim().length <= 0) {
      this.props.toastErrorMsg("Enter Captcha", "txtCaptcha");
    } else if (this.state.formData.txtCaptcha.trim().length < 6) {
      this.props.toastErrorMsg("Enter 6 Digit Captcha", "txtCaptcha");
    } else {
      result = true;
    }
    return result;
  };

  getGSTDetails = () => {
    // let dataLoadStatus = false;
    if (this.validateCaptcha()) {
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "GetInfo",
          gstno: this.state.formData.txtGSTIN,
          captcha: this.state.formData.txtCaptcha,
          captchaCookie: this.state.captchaCookie,
        };

        fetchGSTInfo(reqData)
          .then((res) => {
            // dataLoadStatus = true;
            if (res.data.msgType === "info") {
              // this.props.notifyProcessing();
              this.props.update(
                res.data.message[0].legalNameOfBusiness,
                res.data.message[0].tradeName,
                res.data.message[0].address,
                this.state.formData.txtGSTIN,
                res.data.message[0].state,
                res.data.message[0].statecode,
                res.data.message[0].taxpayertype
              );
              this.setState({ dataLoadStatus: false });
            } else {
              this.props.toastErrorMsg(res.data.message, "txtCaptcha");
              this.setState({ dataLoadStatus: true });
            }
            // setResponseData(res.data.message);
          })
          .catch((error) => {
            console.error("Error fetching or converting image:", error);
            this.setState({ dataLoadStatus: true });
          });
      });
    }
  };

  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
          spacing={2}
          marginTop={0}
          marginLeft={0}
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>GST Info</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtGSTIN"
                  value={this.state.formData.txtGSTIN}
                  label="GSTIN"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="txtCustomerName"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={2}
            >
              <Grid item>
                <img src={`data:image/png;base64,${this.state.base64String}`} />
              </Grid>
              <Grid item>
                <IconButton
                  aria-label="settings"
                  onClick={this.handleConvertToBase64}
                  title="reload"
                >
                  <AutorenewIcon color="primary" />
                </IconButton>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtCaptcha"
                  value={this.state.formData.txtCaptcha}
                  label="Captcha"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={6}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.getGSTDetails}
                  validateInput={this.validateCaptcha}
                  // nextCtrlID="txtCustomerName"
                />
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtBtn label="GST Info." onClick={this.getGSTDetails} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  }
}
export default withRouter(
  connect(mapStatetoProps, mapSetActiveMenuToProps)(HoCtToastContainer(GstInfo))
);
